import script from "./InLogTral.vue?vue&type=script&lang=ts&setup=true"
export * from "./InLogTral.vue?vue&type=script&lang=ts&setup=true"

import "./InLogTral.vue?vue&type=style&index=0&id=4e48a340&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e48a340"]])

export default __exports__